import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Loader from 'features/Loader/Loader';
import TextField from 'shared/components/text-field/TextField';
import Title from 'shared/components/title/Title';
import { renameWorkoutSchema } from 'utils/validators/workout';
import {
  getWorkout,
  resetUniquenessError,
  renameWorkout
} from '../../ducks/workoutActions';

class RenameWorkoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.workoutId = props.match.params.id;
  }

  componentDidMount() {
    this.props.resetUniquenessError();
    this.props.getWorkout(this.workoutId, this.props.history);
  }

  render() {
    let { workout, history, uniquenessError, loadingWorkout, submittingLoading } = this.props;
    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          name: workout.name
        }}
        validationSchema={renameWorkoutSchema}
        onSubmit={values => {
          return values.name === workout.name
            ? history.push(`/workouts/${this.workoutId}`)
            : this.props.renameWorkout(values.name, this.workoutId, history);
        }}
      >
        {formik => (
          <Form>
            {formik.isSubmitting || loadingWorkout || submittingLoading ? (
              <Loader />
            ) : (
              <div className="workout">
                <div className="container">
                  <Breadcrumb>
                    <Breadcrumb.Item href="/workouts">Workouts</Breadcrumb.Item>
                    <Breadcrumb.Item href={`/workouts/${this.workoutId}`}>
                      {workout && workout.name}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Rename Workout</Breadcrumb.Item>
                  </Breadcrumb>                
                </div>
                <div className="rename-plan-form">
                  <Title
                    pageTitle="Rename Workout"
                    buttonText="Save"
                    linkText="Cancel"
                    cancelLink={`/workouts/${this.workoutId}`}
                  />
                  <div className="form-content">
                    <TextField
                      type="text"
                      name="name"
                      label="Workout Name"
                      placeholder="Wholebody Workout B"
                      error={
                        !formik.isSubmitting && uniquenessError
                          ? uniquenessError
                          : false
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    workout: state.workoutReducer.workout,
    loadingWorkout: state.workoutReducer.loading,
    submittingLoading: state.workoutReducer.submittingLoading,
    uniquenessError: state.workoutReducer.uniquenessError
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getWorkout: (workoutId, history) =>
      dispatch(getWorkout(workoutId, history)),
    resetUniquenessError: () => dispatch(resetUniquenessError()),
    renameWorkout: (name, workoutId, history) =>
      dispatch(renameWorkout(name, workoutId, history))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RenameWorkoutForm);
